module.exports = __webpack_public_path__ + "img/bg.03c20224.jpg";